import { checkAcl } from '@flow/libs/utils/acl';

export const canSeeInsightTab = (workspace: Oneflow.Workspace) =>
  checkAcl(workspace.acl, 'collection:ai_review:view_tab');
export const canSeeInsightContent = (workspace: Oneflow.Workspace) =>
  checkAcl(workspace.acl, 'collection:ai_review:view');
export const canEditPlaybook = (workspace: Oneflow.Workspace) =>
  checkAcl(workspace.acl, 'collection:ai_review:admin');
export const hasActivePlaybook = (workspace: Oneflow.Workspace) => workspace?.isAiReviewEnabled;
export const isExtensionEnabled = (account: Oneflow.Account) =>
  Boolean(account.enabledExtensions?.find(({ key }: { key: string }) => key === 'ai_review'));
